import SelectExternalUser from './component';
export default SelectExternalUser;